function HeaderHero() {
  return (
    <header className="hero">
      <nav className="nav">
        <div className="logo">
          <img
            src={`${process.env.PUBLIC_URL}/LOGO.png`}
            alt="GURU KRIPA logo"
            className="logo-image"
          />
          <div className="logo-text">
            <span>GURU KRIPA</span>
            <small>Service and Repair</small>
          </div>
        </div>
        <div className="nav-links">
          <a href="#featured">AC Services</a>
          <a href="#services">Services</a>
          <a href="#cleaning">Cleaning</a>
          <a href="#why">Why Us</a>
          <a href="#contact">Contact</a>
        </div>
        <a className="nav-cta" href="tel:7319963740">
          Call Now
        </a>
      </nav>

      <div className="hero-content">
        <div>
          <p className="eyebrow">Service & Repair Company</p>
          <h1>Trusted AC, Freezer, Washing Machine & Geyser Experts in Your Area</h1>
          <p className="subtitle">
            GURU KRIPA provides fast repairs, deep cleaning, and safe wiring services
            with transparent pricing and same-day support.
          </p>
          <div className="hero-actions">
            <a className="primary-btn" href="#contact">
              Book a Visit
            </a>
            <a
              className="secondary-btn"
              href="https://maps.app.goo.gl/rs1f4VowSRc5AvEu9"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="btn-icon-img"
                src={`${process.env.PUBLIC_URL}/location.png`}
                alt=""
                aria-hidden="true"
              />
              Get Directions
            </a>
            <a className="secondary-btn" href="tel:73199633740">
              +91 7319963740
            </a>
          </div>
          <div className="hero-stats">
            <div>
              <h3>10+ Years</h3>
              <p>Experience</p>
            </div>
            <div>
              <h3>2K+</h3>
              <p>Happy Homes</p>
            </div>
            <div>
              <h3>24/7</h3>
              <p>Support</p>
            </div>
          </div>
        </div>
        <div className="hero-card">
          <h2>Instant Service Request</h2>
          <p>
            Share your issue and we will confirm a visit within minutes. Emergency
            support available.
          </p>
          <div className="hero-card-list">
            <div>
              <span>✔</span>
              Same-day repair
            </div>
            <div>
              <span>✔</span>
              Genuine spare parts
            </div>
            <div>
              <span>✔</span>
              Trained technicians
            </div>
          </div>
          <a className="primary-btn full" href="#contact">
            Request Callback
          </a>
        </div>
      </div>
    </header>
  );
}

export default HeaderHero;
